module.exports = __webpack_public_path__ + "img/icon-face.804fda3a.svg";